export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  filters: {
    keyword: "",
    advanced: {
      name: null,
      status: [],
      emplOfficerId: null,
      academyOfficerId: null,
      telephone: null,
      email: null,
      countries: [],
      legalStatus: [],
      gender: [],
      regDates: [],
      matchedCompanies: [],
      coursesEnrolled: null,
      coursesCompleted: null,
      employabilities: null,
      livelihoods: null,
      route: null,
      sourceChannel: null,
      branch: null,
      isFavorite: null,
      projects: [],
      exclude: false,
      primaryLikedProfession: null,
      secondaryLikedProfession: null,
    },
  },
});
